import React from "react";
import PropTypes from "prop-types";
import { Grid } from "semantic-ui-react";

function ChargeFeeLayout({ children }) {
  const nodes = React.Children.toArray(children);
  return (
    <Grid padded>
      <Grid.Row columns="2">
        <Grid.Column>{nodes[0]}</Grid.Column>
        <Grid.Column textAlign="right">{nodes[1]}</Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column>{nodes.slice(2)}</Grid.Column>
      </Grid.Row>
    </Grid>
  );
}

ChargeFeeLayout.propTypes = {
  children: PropTypes.node
};

export default ChargeFeeLayout;
